// extracted by mini-css-extract-plugin
export default {"inputContainer":"Input_inputContainer__t48bx","input":"Input_input__NxMeV","label":"Input_label__OuF9w"};